import { AgreementFormEnum, EscrowPartyTypeEnum } from 'src/graphql/schema';
import {
  RepresentativesContainer,
  RepresentativesPlaceholder,
  withApiSubmitActions,
} from 'src/containers/Escrow/Representatives';

import { BeneficiaryOrganization } from '.';

import { BeneficiaryContextProvider, useBeneficiaryContext } from '../model';

const Representatives = withApiSubmitActions(RepresentativesContainer, () => {
  const { beneficiary, escrowId, agreementType } = useBeneficiaryContext();

  return {
    role: EscrowPartyTypeEnum.Beneficiary,
    escrowId,
    escrowPartyId: beneficiary!.id,
    contacts: beneficiary!.contacts,
    canUpdate: beneficiary!.policy.update,
    agreementType,
  };
});

type Props = {
  beneficiaryId: string;
  escrowId: string;
  agreementType: AgreementFormEnum;
  canCreateBeneficiary: boolean;
};

const EscrowBeneficiaryCore = ({ beneficiaryId, escrowId, agreementType, canCreateBeneficiary }: Props) => {
  return (
    <BeneficiaryContextProvider
      beneficiaryId={beneficiaryId}
      escrowId={escrowId}
      agreementType={agreementType}
      canCreateBeneficiary={canCreateBeneficiary}
    >
      <BeneficiaryOrganization />
      {beneficiaryId ? <Representatives /> : <RepresentativesPlaceholder role={EscrowPartyTypeEnum.Beneficiary} />}
    </BeneficiaryContextProvider>
  );
};

export default EscrowBeneficiaryCore;
